import axios from "axios";

const state = {
  skills: {},
};

const getters = {
  skills: (state) => state.skills,
};

const actions = {
  async fetchSkills({ commit }) {
    commit("setLoadingSkills", true);
    const res = await axios.get("https://agungsepruloh.herokuapp.com/skills");
    commit("setLoadingSkills", false);
    commit("setSkills", res.data);
  },
};

const mutations = {
  setSkills: (state, skills) => (state.skills = skills),
  setLoadingSkills: (state, value) => (state.skills.isLoading = value),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
